
import { Options, prop, Vue } from "vue-class-component";
import {
  SavedPackageBookingV4,
  ErrorBookingV4,
} from "@/domain/entities/BookingV4";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { ConfigValidationForm } from "@/domain/entities/CreateBookingV3";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import CommodityTooltip from "./commodity-tooltip.vue";

class Props {
  modelValue = prop<SavedPackageBookingV4 | null>({
    required: true,
    default: null,
  });
  errors = prop<ErrorBookingV4>({
    required: true,
    default: () => new ErrorBookingV4(),
    type: Object,
  });
  savedPackages = prop<SavedPackageBookingV4[]>({
    required: true,
    default: () => [],
  });
  configCommodity = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object,
  });
  isForeign = prop<boolean>({
    required: true,
    default: false,
    type: Boolean
  });
  customerId = prop<number>({
    required: true,
    default: 0,
  });
  activeSavedPackageId = prop<number | null>({
    default: null,
  });
}

@Options({
  name: "SavedPackageCards",
  components: {
    CommodityTooltip,
  },
  emits: [
    "selectSavedPackage",
  ],
})
class SavedPackageCards extends Vue.with(Props) {
  mounted() {
    //
  }

  isOpenTooltipCommodity = false;

  get disabledCommodity(): boolean {
    return this.configCommodity.rule.includes(
      ConfigValidationForm.NON_EDITABLE
    );
  }

  isSelectedRecommendation(pkg: SavedPackageBookingV4): boolean {
    if (!this.modelValue) return false;
    return (
      (!!this.modelValue.commodityCode && this.modelValue.commodityCode === pkg.commodityCode) ||
      (!!this.modelValue.id && this.modelValue.id === pkg.id)
    );
  }

  isActiveCard(pkg: SavedPackageBookingV4): boolean {
    return this.activeSavedPackageId === pkg.id;
  }

  toggleTooltip(event: any, code: string) {
    const refs: any = this.$refs;
    refs[code].toggle(event);
  }

  onChoose(pkg: SavedPackageBookingV4) {
    if (this.disabledCommodity) return;

    const target =
      pkg instanceof SavedPackageBookingV4
        ? pkg
        : new SavedPackageBookingV4(pkg);

    this.$emit("selectSavedPackage", target);
  }

  ellipsisText(val: string, length: number) {
    return ellipsisString(val, length);
  }

  displayName(item: SavedPackageBookingV4): string {
    if (!item) return "";
    if (this.isForeign && item.commodityNameEn) return this.toSentenceCase(item.commodityNameEn);
    return this.toSentenceCase(item.commodityName || "");
  }

  toSentenceCase(val: string): string {
    if (!val) return "";
    const isAllUpper = val === val.toUpperCase() && val !== val.toLowerCase();
    if (!isAllUpper) return val;

    return val
      .toLowerCase()
      .split(" ")
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
      .join(" ");
  }

  get commoditiesLength(): string {
    return `(${this.savedPackages.length})`;
  }
}

export default SavedPackageCards;
